module.exports = __webpack_public_path__ + "static/media/edit.98bc7436.svg";